import DemoBadge from '@/components/feature/DemoBadge';

export default function WorkflowHero() {
  return (
    <section className="relative bg-foreground-950 pt-28 md:pt-40 pb-14 md:pb-20 px-4 md:px-8 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20wide%20view%20of%20a%20golf%20course%20fairway%20at%20dawn%20rendered%20as%20a%20clean%20geometric%20editorial%20illustration%20with%20flowing%20data%20lines%20and%20soft%20glow%2C%20deep%20forest%20green%20tones%20with%20dark%20edges%20for%20text%20contrast%2C%20minimal%20modern%20style%2C%20no%20people%20no%20logos&width=1920&height=1080&seq=gs-how-hero&orientation=landscape"
        alt="Stylized golf course illustration"
        title="GreenSide News AI workflow concept"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/75 to-foreground-950/45"></div>
      <div className="relative">
        <div className="flex flex-wrap items-center gap-3">
          <p className="gs-rise font-label uppercase tracking-[0.25em] text-sm text-accent-400 font-bold">How it works</p>
          <DemoBadge label="Conceptual preview" tone="dark" />
        </div>
        <h1 className="gs-rise-2 font-heading font-extrabold uppercase text-background-50 text-4xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tight mt-2 max-w-5xl">
          The publishing engine, on autopilot.
        </h1>
        <p className="gs-rise-3 mt-5 text-background-200 text-base md:text-lg max-w-2xl">
          A look at the AI-assisted workflow GreenSide News plans to run once the platform is built &mdash; always with a human editor in the loop.
        </p>
        <div className="gs-rise-3 mt-7 inline-flex items-center gap-2.5 bg-accent-500 text-foreground-950 font-label font-bold uppercase tracking-widest text-[11px] md:text-xs px-4 py-3 rounded-md">
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-flask-line"></i></span>
          Conceptual Preview &mdash; AI Automation Not Yet Operational
        </div>
      </div>
    </section>
  );
}